import * as UserOnBoarding from './onboardingService';
import * as Signup from './signupService';
import * as AuthService from './authService';
import * as Organisation from './OrganisationProfileService';

const ApiServices = {
  ...AuthService,
  ...UserOnBoarding,
  ...Signup,
  ...Organisation,
};

export default ApiServices;
